import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export const useMutationObserver = (
	ref: RefObject<Element | Document | null>,
	callback: MutationCallback,
	options: MutationObserverInit,
): void => {
	const observer = useRef<MutationObserver | null>(null);

	useEffect(() => {
		if (ref.current) {
			observer.current = new MutationObserver(callback);
			observer.current.observe(ref.current, options);
		}

		return () => observer.current?.disconnect();
	}, [callback, options, ref]);
};
